import { createContext, useMemo, useState } from 'react';

import { sidebarItems } from '../sidebar/sidebar';

interface SearchContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}
type Option = {
  label: string;
  value: string;
  path?: string;
  icon: React.ReactNode;
};

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: { children: React.ReactNode }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const value = useMemo(() => ({ searchTerm, setSearchTerm }), [searchTerm]);

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};

export const useSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const allItems = sidebarItems.flatMap((section) => section.items?.flatMap((subcategory) => subcategory.items || []) || []);

  const options = allItems
    .filter((item) => typeof item.path === 'string')
    .map((item) => ({
      label: item.label,
      value: item.path!,
      path: item.path,
      icon: item.icon,
    }));

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
  const safeOptions = filteredOptions.filter((opt) => opt.value !== null && opt.value !== undefined) as Option[];

  return { searchTerm, setSearchTerm, safeOptions };
};
